import React from "react";

const Blob = () => {
  return (
    <svg
      width="329"
      height="331"
      viewBox="0 0 329 331"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M175.096 65.7001C198.819 71.1119 220.606 74.764 240.017 86.0613C259.385 97.3834 276.378 116.351 284.216 139.395C292.054 162.438 290.806 189.577 281.586 214.469C272.324 239.386 255.089 262.056 233.845 260.738C212.643 259.396 187.432 234.065 160.447 230.479C133.462 226.893 104.772 245.069 84.5259 241.793C64.3231 238.493 52.5644 213.741 47.8479 188.032C43.1745 162.297 45.457 135.655 55.3428 111.817C65.1854 88.0045 82.6314 66.9965 104.141 60.1032C125.694 53.1849 151.329 60.3132 175.096 65.7001Z"
        fill="#005E80"
        fillOpacity="0.1"
      />
    </svg>
  );
};

export default Blob;
